import MainAccordion from "../Accordion/MainAccordion";
import AppActivitiesOrder from "./AppActivitiesOrder";

const AppActivitiesOrderAccordian = ({
  trialDetails,
  setTrialDetails,
  hasBasicInfoChanged,
  setHasBasicInfoChanged,
  handleBasicInfoUpdate,
}) => {
  return (
    <MainAccordion
      title="App Activities Order"
      data={
        <AppActivitiesOrder
          trialDetails={trialDetails}
          setTrialDetails={setTrialDetails}
          hasBasicInfoChanged={hasBasicInfoChanged}
          setHasBasicInfoChanged={setHasBasicInfoChanged}
          handleBasicInfoUpdate={handleBasicInfoUpdate}
        />
      }
    />
  );
};

export default AppActivitiesOrderAccordian;
